import React, { useEffect, useState } from 'react';
import { Slider, Tooltip } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Graph } from '@antv/x6'

const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 240px;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #000;
  font-size: 14px;
`;

const ValueDisplay = styled.span`
  min-width: 48px;
  text-align: right;
  cursor: pointer;
`;

const MIN_ZOOM_FACTOR = 50;
const MAX_ZOOM_FACTOR = 200;

interface ZoomFactorProps {
  value?: number;
  onChange?: (value: number) => void;
  graph?: Graph;
}

export const ZoomFactor: React.FC<ZoomFactorProps> = ({ value: initValue, onChange, graph }) => {
  const [value, setValue] = useState(initValue ?? 100);

  useEffect(() => {
    if (initValue)
      setValue(initValue)
  }, [initValue])

  useEffect(() => {
    if (graph) {
      graph.on('scale', (e) => {
        setValue(Math.round(e.sx * 100))
      })
    }
  }, [graph])

  const handleDecrease = () => {
    const next = Math.max(MIN_ZOOM_FACTOR, value - 1)
    handleChange(next)
  };

  const handleIncrease = () => {
    const next = Math.min(MAX_ZOOM_FACTOR, value + 1)
    handleChange(next)
  };

  const handleChange = (value: number) => {
    const rounded = Math.round(value)
    setValue(rounded);
    onChange?.(rounded);
  }

  return (
    <SliderContainer>
      <IconWrapper onClick={handleDecrease}>
        <MinusOutlined />
      </IconWrapper>
      
      <Slider 
        value={value}
        onChange={handleChange}
        min={MIN_ZOOM_FACTOR}
        max={MAX_ZOOM_FACTOR}
        step={2}
        style={{ flex: 1 }}
      />
      
      <IconWrapper onClick={handleIncrease}>
        <PlusOutlined />
      </IconWrapper>
      <Tooltip title="Reset to 100%">
        <ValueDisplay onClick={() => handleChange(100)}>{value}%</ValueDisplay>
      </Tooltip>

      
    </SliderContainer>
  );
};